export function getCookie(cname: string): string {
  const name = cname + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) !== -1) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

export function setCookie(name: string, value: string, days: number, domain?: string) {
  const d = new Date();
  d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = 'expires=' + d.toUTCString();
  let domainPart = '';
  if (domain) {
    domainPart = '; domain=' + domain;
  }
  document.cookie = name + '=' + value + '; ' + expires + '; path=/' + domainPart;
}

export function hasComfortCookie(): boolean {
  return getCookie('acceptCookies') === 'all';
}
